module.exports = __webpack_public_path__ + "static/media/flow.54a8e3a0.png";